import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  SWITCH_ACCOUNT,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  authUser: null,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: "",
      }
      break

    case SWITCH_ACCOUNT:
      state = {
        ...state,
        loading: true,
        error: "",
      }
      break

    case LOGIN_SUCCESS:
      state = {
        ...state,
        error: "",
        loading: false,
        authUser: action.payload,
      }
      break
    case REFRESH_TOKEN:
      state = {
        ...state,
        error: "",
      }
      break
    case REFRESH_TOKEN_SUCCESS:
      state = {
        ...state,
        authUser: { ...state.authUser, ...action.payload },
        error: "",
      }
      break
    case LOGOUT_USER:
      state = { ...state, error: "" }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state, authUser: null, error: "" }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
